import {gql} from '@apollo/client';

export const sprintMutations = {
    CREATE_SPRINT: gql`
        mutation CreateSprint($input: SprintCreateRequestModelInput!) {
            createSprint(input: $input) {
                id
                title
                startData
                endData
                boardId
                details
                isPinned
            }
        }
    `,
    UPDATE_SPRINT: gql`
        mutation UpdateSprint($input: SprintUpdateRequestModelInput!) {
            updateSprint(input: $input) {
                id
                title
                startData
                endData
                boardId
                details
                isPinned
            }
        }
    `,
};
